// pages/mind-mesch/Help.js

import React from 'react';

const Help = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Help & Support</h1>
      <p>If you’re experiencing issues or have questions about using Mind Mesch, you’re in the right place.</p>

      <h3>Basic Troubleshooting</h3>
      <ul>
        <li>Clear your browser cache and refresh the page.</li>
        <li>Ensure you're using a supported browser (latest Chrome, Edge, or Safari).</li>
        <li>Check your internet connection if pages aren’t loading.</li>
      </ul>

      <h3>Contact Us</h3>
      <p>Email: <a href="mailto:support@mind-mesch.com">support@mind-mesch.com</a></p>
    </div>
  );
};

export default Help;
